module.exports = __webpack_public_path__ + "assets/img/faspay_711.6f233031.png";